import DefaultPageWithBreadcrumbs from 'src/backoffice-app-code/components/page/DefaultPageWithBreadcrumbs';
import { SendNotificationToAllUsersPageForm } from './components';

export const SendNotificationToAllUsersPage: React.FC = () => {
  return (
    <DefaultPageWithBreadcrumbs
      title="Pošaljite notifikaciju"
      links={[
        {
          name: 'Pošaljite notifikaciju',
        },
      ]}
    >
      <SendNotificationToAllUsersPageForm />
    </DefaultPageWithBreadcrumbs>
  );
};
